<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import BasicTextarea from '~/components/form-elements/BasicTextarea.vue'
import CustomModalWindow from '~/components/modal-windows/CustomModalWindow.vue'
import { useProductQuestionsStore } from '~/store/product-questions'

const model = defineModel<boolean>()

const props = defineProps<{
  productId: string
}>()

const productQuestionsStore = useProductQuestionsStore()

const title = 'Задать вопрос о товаре'

function beforeOpen (): void {
  productQuestionsStore.form.productId = props.productId
}

function close (): void {
  model.value = false

  productQuestionsStore.clearForm()
}

async function saveChanges (): Promise<void> {
  await productQuestionsStore.createProductQuestion()

  close()
}
</script>

<template>
  <CustomModalWindow
    v-model="model"
    :has-unsaved-changes="productQuestionsStore.hasUnsavedChanges"
    prevent-unsaved-changes
    size="medium"
    @before-open="beforeOpen"
  >
    <template #title>
      {{ title }}
    </template>

    <form class="mb-6" @change="productQuestionsStore.hasUnsavedChanges = true" @submit.prevent>
      <BasicTextarea
        v-model="productQuestionsStore.form.question"
        is-required
        label-text="Вопрос"
        :max-length="1000"
      />
    </form>

    <BasicButton
      color="green"
      :is-loading="productQuestionsStore.isLoading"
      title="Отправить"
      @click="saveChanges"
    />

    <template #action>
      <a href="#" @click.prevent="close">Закрыть</a>
    </template>
  </CustomModalWindow>
</template>
